import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Tag, Spin } from "../../BP2Components";
import { addGeneralTimer, initiateTimer, stopTimer } from "../../../services/restAPI/RestApi";
import "./timer.less";
import moment from "moment/moment";
import { Icon_Pause, Icon_Start } from "../../BP2Components/Icons/icons";
import projectConfig from "@projectConfig";

const Timer = ({ instanceId, instanceStepId }) => {
   const { oldId: userOldId } = useSelector(({ user }) => user);

   const [timer, setTimer] = useState();
   const [isTimerActive, setIsTimerActive] = useState();
   const [startCountTime, setStartCountTime] = useState();
   const [timeInCase, setTimeInCase] = useState();

   useEffect(() => {
      if (!instanceId || !instanceStepId || !userOldId) return;
      addGeneralTimer({
         instanceId,
         instanceStepId,
         userOldId,
      })
         .then((res) => {
            setTimer(res.data);
            setStartCountTime(moment().startOf("day")?.add(res.data?.timeSpend, "seconds"));
            if (res.data.timerStatus === "STOPPED") {
               initiateTimer(res.data.timerId).then((res) => setTimer(res.data));
            }
         })
         .catch((err) => console.log(err));
   }, []);

   useEffect(() => {
      timer?.timerStatus === "RUNNING" ? setIsTimerActive(true) : setIsTimerActive(false);
   }, [timer?.timerStatus, timer?.lastRequestTime]);

   useEffect(() => {
      if (!startCountTime || !isTimerActive) return;

      const interval = setInterval(() => {
         const time = startCountTime.add(1, "second").format("HH:mm:ss");
         setTimeInCase(time);
      }, 1000);

      return () => clearInterval(interval);
   }, [isTimerActive, startCountTime, timer?.lastRequestTime]);

   useEffect(() => {
      return () => {
         if (timer?.timerStatus === "RUNNING") {
            stopTimer(timer?.timerId);
            window.removeEventListener("beforeunload", handleUnload);
         }
      };
   }, [timer?.timerId, timer?.instanceStepId]);

   useEffect(() => {
      if (timer) {
         window.addEventListener("beforeunload", handleUnload);
      }
      return () => {
         window.removeEventListener("beforeunload", handleUnload);
      };
   }, [timer]);

   const handlePauseAndStart = () => {
      initiateTimer(timer.timerId)
         .then((res) => {
            setTimer(res.data);
         })
         .catch((err) => console.log(err));
   };

   const handleUnload = () => {
      stopTimer(timer?.timerId);
   };

   if (projectConfig.hideTimer) return null;

   return (
      <>
         {timer && timeInCase ? (
            <div className="timer-container">
               <div className="timer">
                  <Tag>{timeInCase}</Tag>
               </div>
               <div className="timer-btns">
                  {isTimerActive ? (
                     <Button buttonType="third" size="small" onClick={handlePauseAndStart}>
                        <Icon_Pause fill="var(--first)" />
                     </Button>
                  ) : (
                     <Button buttonType="third" size="small" onClick={handlePauseAndStart}>
                        <Icon_Start fill="var(--first)" />
                     </Button>
                  )}
               </div>
            </div>
         ) : (
            <Spin style={{ marginLeft: "auto" }} />
         )}
      </>
   );
};

export default Timer;
